import { Input, Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { ApplicationState } from '../../store/application-store';
import { PreviewModeService } from '../../preview-mode/services/preview-mode.service';
import * as userSettingsActions from '../../user-settings/actions/user-settings';
import { PreviewModeDialogResult } from '../../preview-mode/models/preview-mode-dialog-result';
import { PmaEntityLookupHttpService } from '@feature/pma-entity/services/pma-entity-lookup-http.service';
import { SelectItem } from 'primeng/api';
import {
  ClientKey,
  ClientParentKey,
  EntityKey,
  EntityLookupItemDto
} from '@feature/pma-entity/pma-entity-types';
import {OverviewService} from "@feature/overview";

interface ClientFilter {
  ClientRef?: number;
  ClientParentRef?: number;
  EntityKey: EntityKey;
}

@Component({
  selector: 'mojo-mci-preview-mode-dialog-container',
  templateUrl: './mci-preview-mode-dialog-container.component.html'
})
export class MciPreviewModeDialogContainerComponent
  implements OnInit {

  clients$: Observable<SelectItem[]>;
  clientParents$: Observable<SelectItem[]>;

  @Input() showDialog: boolean;

  @Output() showDialogChange = new EventEmitter<boolean>();

  constructor(
    private readonly store: Store<ApplicationState>,
    private readonly previewModeService: PreviewModeService,
    private readonly lookup: PmaEntityLookupHttpService,
    private readonly router: Router,
    private readonly overviewService: OverviewService)
  { }

  ngOnInit() {
  }

  cancelHandler(): void {
    this.showDialog = false;
    this.showDialogChange.emit(this.showDialog);
  }

  okHandler(result: PreviewModeDialogResult): void {
    const f = this.getClientFilter(result);
    this.previewModeService.enterMciPreviewMode(f.ClientRef, f.ClientParentRef)
      .subscribe((result) => {
        if (result) {
          this.store.dispatch(new userSettingsActions.Load());
          this.overviewService.loadOverview(f.EntityKey);
          this.overviewService.loadOverviewConfiguration();
          this.router.navigated = false;
          this.router.navigate(['/main']);
        }
      });

    this.showDialog = false;
    this.showDialogChange.emit(this.showDialog);
  }

  /**
   * only query for clients and client parents when the dialog is being opened
   * instead of when the component is initialized which occurs when a new overview level
   * is entered lister page / dashboard is loaded
   */
  doShowDialog(): void {

    this.clients$ = this.lookup.lookup('Client', '')
      .pipe(map<EntityLookupItemDto[], SelectItem[]>(keys => keys.map(k => ({ label: k.Name, value: k.Key }))));

    this.clientParents$ = this.lookup.lookup('ClientParent', '')
      .pipe(map<EntityLookupItemDto[], SelectItem[]>(keys => keys.map(k => ({ label: k.Name, value: k.Key }))));

    this.showDialog = true;
  }

  getClientFilter(result: PreviewModeDialogResult): ClientFilter {
    const f = result.refType === 'Client Parent'
      ? <ClientFilter> {
        ClientParentRef: result.ref,
        EntityKey: new ClientParentKey()
      }
      : <ClientFilter> {
        ClientRef: result.ref,
        EntityKey: new ClientKey()
      };
    f.EntityKey['Ref'] = result.ref;
    return f;
  }
}
